import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import NavLeft from './NavLeft';
import NavRight from './NavRight';

import { ConfigContext } from '../../../contexts/ConfigContext';
import * as actionType from '../../../store/actions';
import { useCampaignGenarationContext } from 'src/layouts/CampaignGenarionLayout';
import CustomNavRight from './NavRight/CustomNavRight';
import useMenuItems from '../Navigation/useNewMenuItems';
import logo from 'src/assets/images/logo_new.svg';

const NavBar = ({ activeProfiles, isFullScreen, enableFullscreen, isTrail = false, listTotalCount}) => {
  console.log('--defaultActive', activeProfiles);
  //const [moreToggle, setMoreToggle] = useState(false);
  const configContext = useContext(ConfigContext);
  const { collapseMenu, headerBackColor, headerFixedLayout, layout, subLayout } = configContext.state;
  const { dispatch } = configContext;
  const campaignContext = useCampaignGenarationContext()
  const { isLandingPage } = campaignContext || {}
  const { menuItems } = useMenuItems();
  const hasNoSidemenu = menuItems.length === 0;

  let headerClass = ['navbar', 'pcoded-header', 'navbar-expand-lg', headerBackColor];
  if (headerFixedLayout && layout === 'vertical') {
    headerClass = [...headerClass, 'headerpos-fixed'];
  }

  let toggleClass = ['mobile-menu'];
  if (!collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  const navToggleHandler = () => {
    dispatch({ type: actionType.COLLAPSE_MENU });
  };

  // let moreClass = ['mob-toggler'];;
  // if (layout === 'horizontal') {
  //     moreClass = [...moreClass, 'd-none'];
  // }
  let collapseClass = [`collapse navbar-collapse bg-white mildshadow header-fixed w-inherit hei-50 px-3 px-lg-0 ${window.location.href.indexOf('/amazon-dayparting') > -1 ? "border-bottom shadow-none" : "" } `];
  // if (moreToggle) {
  //     //moreClass = [...moreClass, 'on'];
  //     collapseClass = [...collapseClass, 'd-block']
  // }

  let navBar = (
    <React.Fragment>
      <div className="m-header">
        {!hasNoSidemenu && (
          <Link to="#" className={toggleClass.join(' ')} id="mobile-collapse" onClick={navToggleHandler}>
            <span />
          </Link>
        )}
        {!hasNoSidemenu && (
          <Link to="/" className="b-brand">
            <div className="b-bg">
              <i className="feather icon-trending-up" />
            </div>
          </Link>
        )}
        {/* <Link to='#' className={moreClass.join(' ')} onClick={() => setMoreToggle(!moreToggle)}>
                    <i className="feather icon-more-vertical"/>
                </Link> */}
      </div>
      <div className={collapseClass.join(' ')}>
        {hasNoSidemenu && (
          <Link to="/" className="header-logo-link d-flex align-items-center mr-3" style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 16, background: 'transparent' }}>
            <img src={logo} alt="Hector" className="hector-logo" style={{ height: '32px', width: 'auto' }} />
          </Link>
        )}
        <NavLeft hideLogo={hasNoSidemenu} />
        {isLandingPage ? <CustomNavRight /> : <NavRight activeProfiles={activeProfiles} isFullScreen={isFullScreen} enableFullscreen={enableFullscreen} listTotalCount={listTotalCount} />}
      </div>
    </React.Fragment>
  );

  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBar = <div className="container">{navBar}</div>;
  }

  if(isTrail == true) headerClass = headerClass.concat('custom-top-51 billing_notify')

  return (
    <React.Fragment>
      <header className={headerClass.join(' ')} style={isTrail == true ? { top: '51px !important' } : {}}>{navBar}</header>
    </React.Fragment>
  );
};

export default NavBar;
